import $ from 'jquery';

$(document).ready(function() {
  $('.author__block-show-item').on('click', function() {
    $('.author__block-show-item').removeClass('closed');
    $(this).addClass('closed');
    $('.author__block-full-info')
      .stop(true, true)
      .slideToggle('slow');
    $('.author__block-info').toggleClass('active');
    $('.icon-author-vector').toggleClass('active');
  });

  if ($('.author .author__block-info-text').length === 1) {
    var infoShow = $('.author__block-info-text').prop('scrollHeight');
    if (infoShow > 95) {
      $('.author__block-show').css({ display: 'flex' });
    }
  }
});
